// import React, { useState } from "react";

// const ServicesInvoiceModal = ({ isOpen, onClose, invoices }) => {
//   const [selectedInvoiceDetails, setSelectedInvoiceDetails] = useState(null);

//   if (!isOpen) return null;

//   const groupedInvoices = invoices.reduce((acc, invoice) => {
//     const existingInvoice = acc[invoice.invoice];
//     if (existingInvoice) {
//       existingInvoice.quantity += invoice.quantity;
//       existingInvoice.total += invoice.quantity * invoice.unit_price;
//     } else {
//       acc[invoice.invoice] = {
//         invoice: invoice.invoice,
//         patient_name: invoice.patient_name,
//         doctor_name: invoice.doctor_name,
//         date: invoice.sale_date,
//         quantity: invoice.quantity,
//         total: invoice.quantity * invoice.unit_price,
//       };
//     }
//     return acc;
//   }, {});

//   const uniqueInvoices = Object.values(groupedInvoices);

//   const handleViewInvoice = (invoiceName) => {
//     const filteredDetails = invoices.filter(
//       (invoice) => invoice.invoice === invoiceName
//     );
//     setSelectedInvoiceDetails(filteredDetails);
//   };

//   const closeInvoiceDetails = () => {
//     setSelectedInvoiceDetails(null);
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return ""; // Handle null or undefined
//     const options = { year: "numeric", month: "short", day: "numeric" };
//     return new Date(dateString).toLocaleDateString("en-US", options);
//   };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//       <div className="ml-32 bg-white rounded-lg shadow-lg w-full max-w-6xl p-6">
//         <div className="grid grid-cols-3 justify-between items-center border-b pb-4">
//           <div></div>
//           <h2 className="text-2xl font-semibold text-gray-700 text-center">Invoices</h2>
//           <div className="flex justify-end">
//           <button
//             className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
//             onClick={onClose}
//           >
//             &times;
//           </button>
//           </div>
//         </div>

//         <div className="mt-4 overflow-y-auto max-h-96">
//           {uniqueInvoices.length > 0 ? (
//             <table className="table-auto w-full text-left text-gray-700 border-collapse">
//               <thead>
//                 <tr className="bg-gray-100">
//                   <th className="p-3 border-b">Invoice No.</th>
//                   <th className="p-3 border-b">Date</th>
//                   <th className="p-3 border-b">Time</th>
//                   <th className="p-3 border-b">Patient</th>
//                   <th className="p-3 border-b">Doctor</th>
//                   <th className="p-3 border-b">Quantity</th>
//                   <th className="p-3 border-b">Amount</th>
//                   <th className="p-3 border-b text-center">Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {uniqueInvoices.map((invoice, index) => {

//                   const dateObj = new Date(invoice.date);
//                   const formattedDate = dateObj.toLocaleDateString("en-US", {
//                     month: "short",
//                     day: "2-digit",
//                     year: "numeric",
//                   });
//                   const formattedTime = dateObj.toLocaleTimeString("en-US", {
//                     hour: "2-digit",
//                     minute: "2-digit",
//                     hour12: true,
//                   });
//                   return (
//                   <tr key={index} className="hover:bg-gray-50">
//                     <td className="p-3 border-b font-serif">
//                       {invoice.invoice}
//                     </td>
//                     <td className="p-3 border-b">{formattedDate}</td>
//                     <td className="p-3 border-b">{formattedTime}</td>
//                     <td className="p-3 border-b">{invoice.patient_name}</td>
//                     <td className="p-3 border-b">{invoice.doctor_name}</td>
//                     <td className="p-3 border-b">{invoice.quantity}</td>
//                     <td className="p-3 border-b">
//                       Rs.{invoice.total.toFixed(2)}
//                     </td>
//                     <td className="p-3 border-b">
//                       <button
//                         className="bg-gray-500 text-white px-4 py-2 rounded-md hover:bg-gray-600"
//                         onClick={() => handleViewInvoice(invoice.invoice)}
//                       >
//                         View Invoice
//                       </button>
//                     </td>
//                   </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           ) : (
//             <p className="text-gray-500">No invoices available.</p>
//           )}
//         </div>
//       </div>

//       {selectedInvoiceDetails && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="ml-32 bg-white rounded-lg shadow-lg w-full max-w-6xl p-6">
//             <div className="flex justify-between items-center border-b pb-4">
//               <div className="flex flex-col">
//                 <h3 className="text-xl font-semibold text-gray-700">
//                   Services for Invoice No. {selectedInvoiceDetails[0].invoice}
//                 </h3>
//                 <h3 className="text-xl text-gray-700">
//                   {selectedInvoiceDetails[0].patient_name}
//                 </h3>
//                 <h3 className="text-xl font-semibold text-gray-700">
//                   {formatDate(selectedInvoiceDetails[0].sale_date)}
//                 </h3>
//               </div>
//               <button
//                 className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
//                 onClick={closeInvoiceDetails}
//               >
//                 &times;
//               </button>
//             </div>

//             <div className="mt-4 overflow-y-auto max-h-96">
//               <table className="table-auto w-full text-left text-gray-700 border-collapse">
//                 <thead>
//                   <tr className="bg-gray-100">
//                     <th className="p-2 border-b">Service Name</th>
//                     <th className="p-2 border-b">Quantity</th>
//                     <th className="p-2 border-b">Unit Price</th>
//                     <th className="p-2 border-b">Total</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {selectedInvoiceDetails.map((item, index) => (
//                     <tr key={index} className="hover:bg-gray-50">
//                       <td className="p-2 border-b">{item.service_name}</td>
//                       <td className="p-2 border-b">{item.quantity}</td>
//                       <td className="p-2 border-b">Rs.{item.unit_price}</td>
//                       <td className="p-2 border-b">
//                         Rs.{(item.quantity * item.unit_price).toFixed(2)}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//               {/* Total Calculation */}
//               <div className="mt-4 flex text-xl font-semibold text-gray-700">
//                 <span>Total:</span>
//                 <span className="ml-auto mr-[160px]">
//                   Rs.
//                   {selectedInvoiceDetails
//                     .reduce(
//                       (total, item) => total + item.quantity * item.unit_price,
//                       0
//                     )
//                     .toFixed(2)}
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ServicesInvoiceModal;

import React, { useState } from "react";

const ServicesInvoiceModal = ({ isOpen, onClose, invoices }) => {
  const [selectedInvoiceDetails, setSelectedInvoiceDetails] = useState(null);

  if (!isOpen) return null;

  const groupedInvoices = invoices.reduce((acc, invoice) => {
    const existingInvoice = acc[invoice.invoice];
    if (existingInvoice) {
      existingInvoice.quantity += invoice.quantity;
      existingInvoice.total += invoice.quantity * invoice.unit_price;
    } else {
      acc[invoice.invoice] = {
        invoice: invoice.invoice,
        patient_name: invoice.patient_name,
        doctor_name: invoice.doctor_name,
        date: invoice.sale_date,
        quantity: invoice.quantity,
        total: invoice.quantity * invoice.unit_price,
      };
    }
    return acc;
  }, {});

  const uniqueInvoices = Object.values(groupedInvoices);

  const handleViewInvoice = (invoiceName) => {
    setSelectedInvoiceDetails(
      invoices.filter((inv) => inv.invoice === invoiceName),
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const totalAmount =
    selectedInvoiceDetails?.reduce(
      (sum, item) => sum + item.quantity * item.unit_price,
      0,
    ) ?? 0;

  return (
    <div
      className="fixed inset-0 bg-black/50 flex justify-center items-center z-50 p-2 sm:p-4 md:p-6"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full
          max-w-full sm:max-w-[90%] md:max-w-[80%] lg:max-w-[70%]
          max-h-[95vh] sm:max-h-[94vh] flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="bg-[#215187] px-4 py-3 sm:px-5 sm:py-4 flex items-center justify-between flex-shrink-0">
          <div className="min-w-0 mr-3">
            <p className="text-[10px] font-medium uppercase tracking-widest text-gray-400">
              Service Records
            </p>
            <p className="text-white font-semibold text-sm sm:text-base leading-tight mt-0.5">
              Invoices
            </p>
          </div>
          <button
            onClick={onClose}
            className="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-full
              bg-white/10 text-gray-300 hover:bg-white/20 hover:text-white
              transition-all duration-200 text-lg font-bold leading-none"
          >
            &times;
          </button>
        </div>

        {/* Info Strip */}
        <div className="bg-gray-50 border-b border-gray-100 px-4 py-2.5 sm:px-5 sm:py-3 flex items-center gap-2 sm:gap-3 flex-shrink-0">
          <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-[#215187] flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
            S
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-xs sm:text-sm font-semibold text-gray-800">
              All Invoices
            </p>
            <p className="text-[11px] text-gray-400">
              {uniqueInvoices.length} record(s) found
            </p>
          </div>
          <span className="flex-shrink-0 text-[10px] sm:text-[11px] font-semibold px-2 py-0.5 sm:px-2.5 sm:py-1 rounded-full bg-blue-50 text-blue-600 border border-blue-100 whitespace-nowrap">
            Services
          </span>
        </div>

        {/* Table */}
        <div className="overflow-y-auto overflow-x-auto flex-1 px-3 py-3 sm:px-5 sm:py-4">
          {uniqueInvoices.length > 0 ? (
            <table className="w-full min-w-[600px] text-xs sm:text-sm border-collapse">
              <thead>
                <tr className="bg-gray-50">
                  {[
                    "#",
                    "Invoice No.",
                    "Date",
                    "Time",
                    "Patient",
                    "Doctor",
                    "Qty",
                    "Amount",
                    "Action",
                  ].map((h) => (
                    <th
                      key={h}
                      className="text-[9px] sm:text-[10px] font-bold uppercase tracking-widest text-gray-400 px-3 py-2.5 text-left whitespace-nowrap"
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {uniqueInvoices.map((invoice, index) => {
                  const dateObj = new Date(invoice.date);
                  return (
                    <tr
                      key={index}
                      className="border-b border-gray-100 hover:bg-gray-50 transition-colors"
                    >
                      <td className="px-3 py-2.5 text-gray-400 font-medium">
                        {index + 1}
                      </td>
                      <td className="px-3 py-2.5 text-gray-800 font-medium whitespace-nowrap">
                        {invoice.invoice}
                      </td>
                      <td className="px-3 py-2.5 text-gray-600 whitespace-nowrap">
                        {dateObj.toLocaleDateString("en-US", {
                          month: "short",
                          day: "2-digit",
                          year: "numeric",
                        })}
                      </td>
                      <td className="px-3 py-2.5 text-gray-600 whitespace-nowrap">
                        {dateObj.toLocaleTimeString("en-US", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}
                      </td>
                      <td className="px-3 py-2.5 text-gray-800 font-medium">
                        {invoice.patient_name}
                      </td>
                      <td className="px-3 py-2.5 text-gray-500 whitespace-nowrap">
                        {invoice.doctor_name}
                      </td>
                      <td className="px-3 py-2.5 text-gray-600">
                        {invoice.quantity}
                      </td>
                      <td className="px-3 py-2.5 text-gray-800 font-semibold whitespace-nowrap">
                        PKR {Number(invoice.total).toLocaleString()}
                      </td>
                      <td className="px-3 py-2.5">
                        <button
                          onClick={() => handleViewInvoice(invoice.invoice)}
                          className="text-[11px] font-semibold px-3 py-1.5 rounded-lg bg-gray-800 text-white hover:bg-gray-700 transition-colors whitespace-nowrap"
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <div className="text-center py-10 text-gray-400 text-sm">
              No invoices available.
            </div>
          )}
        </div>
      </div>

      {/* Inner Detail Modal */}
      {selectedInvoiceDetails && (
        <div
          className="fixed inset-0 bg-black/50 flex justify-center items-center z-50 p-2 sm:p-4 md:p-6"
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className="bg-white rounded-2xl shadow-2xl w-full
              max-w-full sm:max-w-[90%] md:max-w-[75%] lg:max-w-[60%]
              max-h-[95vh] flex flex-col overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Detail Header */}
            <div className="bg-[#1F2937] px-4 py-3 sm:px-5 sm:py-4 flex items-center justify-between flex-shrink-0">
              <div className="min-w-0 mr-3">
                <p className="text-[10px] font-medium uppercase tracking-widest text-gray-400">
                  Invoice Details
                </p>
                <p className="text-white font-semibold text-sm sm:text-base leading-tight mt-0.5">
                  #{selectedInvoiceDetails[0].invoice}
                </p>
              </div>
              <button
                onClick={() => setSelectedInvoiceDetails(null)}
                className="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-full
                  bg-white/10 text-gray-300 hover:bg-white/20 hover:text-white
                  transition-all duration-200 text-lg font-bold leading-none"
              >
                &times;
              </button>
            </div>

            {/* Detail Info Strip */}
            <div className="bg-gray-50 border-b border-gray-100 px-4 py-2.5 sm:px-5 sm:py-3 flex items-center gap-2 sm:gap-3 flex-shrink-0">
              <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-gray-800 flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
                {selectedInvoiceDetails[0].patient_name
                  ?.charAt(0)
                  ?.toUpperCase() || "P"}
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-xs sm:text-sm font-semibold text-gray-800 truncate">
                  {selectedInvoiceDetails[0].patient_name}
                </p>
                <p className="text-[11px] text-gray-400">
                  {formatDate(selectedInvoiceDetails[0].sale_date)}
                </p>
              </div>
              <span className="flex-shrink-0 text-[10px] sm:text-[11px] font-semibold px-2 py-0.5 sm:px-2.5 sm:py-1 rounded-full bg-blue-50 text-blue-600 border border-blue-100 whitespace-nowrap">
                {selectedInvoiceDetails.length} item(s)
              </span>
            </div>

            {/* Detail Table */}
            <div className="overflow-y-auto overflow-x-auto flex-1 px-3 py-3 sm:px-5 sm:py-4">
              <table className="w-full min-w-[400px] text-xs sm:text-sm border-collapse">
                <thead>
                  <tr className="bg-gray-50">
                    {["#", "Service", "Qty", "Unit Price", "Total"].map((h) => (
                      <th
                        key={h}
                        className="text-[9px] sm:text-[10px] font-bold uppercase tracking-widest text-gray-400 px-3 py-2.5 text-left whitespace-nowrap"
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {selectedInvoiceDetails.map((item, index) => (
                    <tr
                      key={index}
                      className="border-b border-gray-100 hover:bg-gray-50 transition-colors"
                    >
                      <td className="px-3 py-2.5 text-gray-400 font-medium">
                        {index + 1}
                      </td>
                      <td className="px-3 py-2.5 text-gray-800 font-medium">
                        {item.service_name}
                      </td>
                      <td className="px-3 py-2.5 text-gray-600">
                        {item.quantity}
                      </td>
                      <td className="px-3 py-2.5 text-gray-600 whitespace-nowrap">
                        PKR {Number(item.unit_price).toLocaleString()}
                      </td>
                      <td className="px-3 py-2.5 text-gray-800 font-semibold whitespace-nowrap">
                        PKR{" "}
                        {Number(
                          item.quantity * item.unit_price,
                        ).toLocaleString()}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="bg-gray-50 border-t-2 border-gray-200">
                    <td
                      colSpan="4"
                      className="px-3 py-2.5 text-[10px] font-bold uppercase tracking-widest text-gray-500"
                    >
                      Total
                    </td>
                    <td className="px-3 py-2.5 text-gray-800 font-bold whitespace-nowrap">
                      PKR {Number(totalAmount).toLocaleString()}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServicesInvoiceModal;
